import React from "react";
import Typography from "@mui/material/Typography";

const NoOptionsMessage = ({ children, innerProps }) => {
  return (
    <Typography
      sx={{ padding: (theme) => theme.spacing(1, 2) }}
      color="textSecondary"
      {...innerProps}
    >
      {children}
    </Typography>
  );
};

export default NoOptionsMessage;
